/********************************************************* {COPYRIGHT-TOP} ***
 * Licensed Materials - Property of IBM
 *
 * (C) Copyright IBM Corporation 2016, 2024
 *
 * All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 ********************************************************** {COPYRIGHT-END} **/

// Imports from generateWebWorker.js for app build otherwise generatorPromise.js
import sendData from '_APIC_DATA_SENDER_';
class Generator {
  async generateDummyValue(
    valueConfig = {
      propertyName: '',
      property: {},
      empty: false
    }
  ) {
    return await sendData({
      ...valueConfig,
      type: 'value'
    });
  }

  async generateExampleParameter(
    parameterConfig = {
      api: {},
      pathName: '',
      verb: '',
      parameter: {},
      contentTypeHeader: '',
      skipBeautify: false,
      maxDepth: 9,
      references: [],
      numItems: 3
    }
  ) {
    return await sendData({
      ...parameterConfig,
      type: 'parameter'
    });
  }

  async generateExampleResponse(
    responseConfig = {
      api: {},
      path: '',
      verb: '',
      response: '',
      contentType: '',
      config: {},
      maxDepth: 9,
      references: [],
      numItems: 3
    }
  ) {
    return await sendData({
      ...responseConfig,
      type: responseConfig.api.openapi ? 'oai3response' : 'response'
    });
  }

  async generateAsyncApiResponse(
    responseConfig = {
      api: {},
      schema: {},
      contentType: '',
      highlight: true
    }
  ) {
    return await sendData({
      ...responseConfig,
      type: 'eventResponse'
    });
  }

  // generate flattened schema with resolved references
  // returns Promise that resolves with the resolved references
  async generateFlattenedSchema(definitions = {}) {
    // use worker to resolve references, needs object of the schema with definitions as a property
    // so it can resolve #/definitions/address for example
    const data = await sendData({
      schema: definitions,
      type: 'resolveReferences'
    });
    return data.schema;
  }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new Generator();
